var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('v-col',{staticClass:"text-right pa-0"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://www.resumeok.com/"}},[_vm._v("resumeok.com")]),_vm._v(". All rights reserved. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }